/**
 * PM message translation. The panel opens under the bubble, outside
 * .msg_body, so the live-edit swap of .msg-body-text never touches it.
 */

import { closeTranslation, toggleTranslation } from '../../modules/translation-panel.js';

function messageText(msgId) {
  var body = document.querySelector('#msg_' + msgId + ' .msg-body-text');
  return body ? (body.innerText || body.textContent || '').trim() : '';
}

function bubbleWrap(msgId) {
  return document.querySelector('#msg_' + msgId + ' .pm-msg-bubble-wrap');
}

/** A message from another sender whose body has text. */
window.isMessageTranslatable = function (msgId) {
  var msg = document.getElementById('msg_' + msgId);
  if (!msg || String(msg.getAttribute('data-sender-id') || '') === window.pmCurrentUserId()) {
    return false;
  }
  return messageText(msgId) !== '';
};

window.translateMessage = function (msgId) {
  window.closeMessageActionMenus();
  var anchor = bubbleWrap(msgId);
  if (anchor) {
    toggleTranslation(anchor, messageText(msgId), { className: 'max-w-[85vw] sm:max-w-[80%]' });
  }
  // The closed menu hid the item that held focus.
  var toggle = document.querySelector('#msg_' + msgId + ' .msg-actions-toggle');
  if (toggle && toggle.offsetParent !== null) {
    toggle.focus();
  }
};

/** Hide moves focus to the message's options button, which is hidden on phones. */
document.addEventListener('translation-closed', function (event) {
  var wrap = event.target instanceof Element ? event.target.closest('.pm-msg-bubble-wrap') : null;
  var toggle = wrap && wrap.closest('[id^="msg_"]')?.querySelector('.msg-actions-toggle');
  if (event.detail?.hadFocus && toggle && toggle.offsetParent !== null) {
    toggle.focus();
  }
});

/** Drop an open translation once the message text changes. */
window.closeMessageTranslation = function (msgId) {
  closeTranslation(bubbleWrap(msgId));
};
